<template>
    <div v-if="pcRental" class="container-fluid pc-rental">
        <hero-section :section-data="pcRental.landing_page_sections[0]" @scroll-to="scrollTo" />
        <hassle-free-section :section-data="pcRental.landing_page_sections[1]" @scroll-to="scrollTo" />
        <case-section :case-photo="pcRental.landing_page_sections[1].logo_url" />
        <pc-specs-section
            :section-data="pcRental.landing_page_builds[0]"
            :section-buttons="pcRental.landing_page_sections[0]"
            @scroll-to="scrollTo" />
        <sign-up-form-section v-if="!isFormSent" @form-submited="() => isFormSent = true" />
        <success-section v-else @start-over="() => isFormSent = false" />
    </div>
</template>

<script>
import HeroSection from "./hero-section";
import HassleFreeSection from "./hassle-free-section";
import CaseSection from "./case-section";
import SignUpFormSection from "./sign-up-form-section";
import SuccessSection from "./success-section";
import PcSpecsSection from "./pc-specs-section";

export default {
    name: "PCRental",
    components: {
        HeroSection,
        HassleFreeSection,
        CaseSection,
        PcSpecsSection,
        SignUpFormSection,
        SuccessSection
    },
    data() {
        return {
            isFormSent: false,
            pcRental: null
        };
    },
    created() {
        this.getPcRentalData();
    },
    methods: {
        getPcRentalData() {
            axios("/public-landing-pages/rental-pc").then(({data: pcRental}) => this.pcRental = pcRental).catch(error => {
                console.log(error)
            });
        },
        scrollTo(element) {
            this.$scrollTo(element, 300, {
                offset: -88
            });
        }
    }
}
</script>

<style lang="scss">
.pc-rental {
    .btn-green:hover {
        background-color: transparent;
        color: white;
        z-index: 1;
    }
}
</style>
